import React from "react";
import { useTranslation } from "react-i18next";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classNames from "classnames";
// import Preview from "./Preview";
import Banner from "../shopPage/Banner";
import BannerImages from "../../Common/BannerImages";
import LanguageTable from "../../Common/LanguageTable";
import { templateDefaultValue } from "@constants/template";
import { useSelector } from "react-redux";

const AccountClient = React.memo(() => {
    const { t } = useTranslation();
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const [activeTab, setActiveTab] = React.useState<number>(0);
    const profileImagePathDesktop = React.useMemo(
        () => ["SiteWeb", "Profile", "Default", "Header", "Image", "Desktop"],
        []
    );
    const profileImagePathMobile = React.useMemo(
        () => ["SiteWeb", "Profile", "Default", "Header", "Image", "Mobile"],
        []
    );

    const tabs = [
        {
            title: t("My account"),
            content: (
                <div className="banner-container mt-2">
                    <Banner
                        showTitle={true}
                        showDescription={false}
                        showSearch={false}
                        imagePath={[
                            "SiteWeb",
                            "Profile",
                            "Default",
                            "Header",
                            "Image",
                        ]}
                    />
                    <section className="text-section">
                        <p className="image-title">{t("Image banner")}</p>
                        <div className="banner-images">
                            <BannerImages
                                dataPath={profileImagePathDesktop}
                                title="Image Desktop"
                                size="1920*480 (png,jpg,jpeg ou webp)"
                            />
                            <BannerImages
                                dataPath={profileImagePathMobile}
                                title="Image Mobile"
                                size="1920*480 (png,jpg,jpeg ou webp)"
                            />
                        </div>
                        <LanguageTable
                            path={["SiteWeb", "Profile", "Default", "Header"]}
                            fields={[
                                {
                                    key: "Title",
                                    label: "Titre",
                                    placeholder: "Enter the Title",
                                },
                            ]}
                            defaultTexts={
                                templateDefaultValue.SiteWeb.Profile.Default
                                    .Header
                            }
                            sectionTitle="Title"
                        />
                    </section>
                </div>
            ),
            customClassName: "",
        },
    ];

    function toggleNav(tab: number) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    return (
        <div className="d-flex justify-content-between">
            <div style={{ width: "100%" }}>
                <div style={{ borderBottom: "1px solid #ddd4d4" }}>
                    <Nav
                        tabs
                        style={{
                            backgroundColor: "white",
                            width: "50px",
                            display: "grid",
                            gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
                            border: "unset",
                        }}
                    >
                        {tabs.map((element, index) => (
                            <NavItem
                                key={index}
                                className={classNames(
                                    "pb-1",
                                    "d-flex align-items-center text-nowrap",
                                    {
                                        "disable-nav-item__clz":
                                            activeTab !== index,
                                    },
                                    element.customClassName
                                )}
                                style={{
                                    cursor: "pointer",
                                    borderBottom:
                                        activeTab === index
                                            ? `${mainColor} 3px solid`
                                            : "",
                                }}
                            >
                                <NavLink
                                    className={classNames("text-dark w-100", {
                                        "active customer-account-menu-nav-link-active__clz":
                                            activeTab === index,
                                        "customer-account-menu-nav-link-disable__clz":
                                            activeTab !== index,
                                    })}
                                    onClick={() => toggleNav(index)}
                                >
                                    <span
                                        className="px-2"
                                        style={{
                                            font:
                                                "normal normal 600 20px/27px Segoe UI",
                                        }}
                                    >
                                        {element.title}
                                    </span>
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>
                </div>
                <TabContent activeTab={activeTab} className="h-100">
                    {tabs.map((element, index) => (
                        <TabPane
                            tabId={index}
                            key={index}
                            style={{ height: "90%" }}
                        >
                            {element.content}
                        </TabPane>
                    ))}
                </TabContent>
            </div>
        </div>
    );
});

export default AccountClient;
